export enum RequestHeadersEnum {
  TENANT_ID = 'x-tenant-id',
  TENANT_UUID = 'x-tenant-uuid',
  USER_ID = 'x-user-id',
  EVENT_ID = 'x-p44-event-id',
  SOURCE_TENANT_ID = 'x-source-tenant-id',
  PERMISSIONS = 'x-permissions',
  USERNAME = 'x-username',
  CARRIER_NETWORK_ROLES = 'x-carrier-network-roles',
}

export enum AxiosDelegationStrategyEnum {
  REACT_HOOK_DELEGATION = 'REACT_HOOK_DELEGATION',
  EXECUTABLE = 'EXECUTABLE',
}
